import React from "react";
import { CircleSlash } from "lucide-react";

import Heading from "../typography/Heading";
import Text from "../typography/Text";
import Button from "../buttons/Button";

import "./EmptyState.css";

export default function EmptyState({
  icon,
  title = "Nothing here yet",
  description = "No content is currently available.",
  buttonText,
  onAction,
  action,
  className = "",
  style,
}) {
  return (
    <div
      className={["empty-state", className].filter(Boolean).join(" ")}
      style={style}
    >
      <div className="empty-state__icon" aria-hidden="true">
        {icon || <CircleSlash size={28} strokeWidth={1.5} />}
      </div>

      <div className="empty-state__content">
        <Heading as="h2" size="sm">
          {title}
        </Heading>

        {description && (
          <Text as="p" tone="secondary" size="sm">
            {description}
          </Text>
        )}
      </div>

      {action ? (
        <div className="empty-state__actions">{action}</div>
      ) : buttonText && onAction ? (
        <div className="empty-state__actions">
          <Button
            value={buttonText}
            variant="primary-outlined"
            onClick={onAction}
          />
        </div>
      ) : null}
    </div>
  );
}
